import { useRef } from 'react';
import { useScroll, useTransform } from 'framer-motion';

/**
 * Returns a ref to attach to a section and a `y` motion value that drifts
 * as the section scrolls through the viewport — a cheap layered-depth effect.
 */
const useParallax = (distance = 80) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-distance, distance]);
  return { ref, y };
};

export default useParallax;
